import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DoctorStateKyruus, DOCTOR_STATE_REDUX_ID_KYRUUS } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/reducers/doctors.reducer';
import { DoctorStateSapphireDigital, DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL } from 'src/app/angular-elements/medical-information/doctor-information-sapphire-digital/configs/reducers/doctors.reducer';
import { DOCTOR_VENDOR_TYPE } from 'src/app/angular-elements/medical-information/doctor-information/configs/enums/doctor-vendor-type.enum';
import { DoctorVendorTypeState, DOCTOR_VENDOR_TYPE_STATE_REDUX_ID } from 'src/app/angular-elements/medical-information/doctor-information/configs/reducers/doctor-information.reducer';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { MedicationStateStructure } from '../../../medical-information/medication-information/reducers/medication.reducer';
import { PRODUCT_GROUPS } from '../../enums/product-groups.enum';
import { PlanAttributes, SummaryView, ProviderNetworkMap } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { PlanUtilityService } from '../../plan-summary-list/plan-utility.service';
import { MedicalDetailsModalComponent } from '../medical-details-modal/medical-details-modal.component';

@Component({
    selector: 'app-plan-card-coverage-details',
    templateUrl: './plan-card-coverage-details.component.html',
    styleUrls: ['./plan-card-coverage-details.component.scss'],
    standalone: false
})
export class PlanCardCoverageDetailsComponent implements OnInit{
  @Input() plan: Product<PlanAttributes, SummaryView>;
  @Input() addMedicationsUrl: string;
  
  providerPlanInfo: ProviderNetworkMap;
  hasIndividualDrugs: boolean;
  hasSeniorDrugs: boolean;
  showProviderCoverage: boolean;
  hideDrugProviderData: boolean;

  constructor(
    private planUtilityService: PlanUtilityService,
    private matDialog: MatDialog,
    private reducerUtilityService: ReducerUtilityService,
  ) {
    
  }

  ngOnInit() {
    this.providerPlanInfo = this.planUtilityService.getProvidersCoveredByPlan(this.plan);
    const medState: MedicationStateStructure = this.reducerUtilityService.getState('MedicationInformation');

    if (medState?.individualMedications?.length > 0) {
      this.hasIndividualDrugs = true;
    }
    if (medState?.medicationForm?.selectedMedications?.length > 0) {
      this.hasSeniorDrugs = true;
    }

    const doctorVendorState: DoctorVendorTypeState = this.reducerUtilityService.getState(DOCTOR_VENDOR_TYPE_STATE_REDUX_ID);

    if (doctorVendorState.vendorType === DOCTOR_VENDOR_TYPE.SAPPHIRE_DIGITAL) {
      const doctorState: DoctorStateSapphireDigital = this.reducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL);
      this.showProviderCoverage = (
        doctorState &&
        doctorState.doctors &&
        doctorState.doctors.length &&
        doctorState.doctors.length > 0
      );
    } else if (doctorVendorState.vendorType === DOCTOR_VENDOR_TYPE.KYRUUS) {
      const doctorState: DoctorStateKyruus = this.reducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_KYRUUS);
      this.showProviderCoverage = (
        doctorState &&
        doctorState.doctors &&
        doctorState.doctors.length &&
        doctorState.doctors.length > 0
      );
    }

    if (this.plan && this.plan.attributes && this.plan.attributes.PRODUCT_GROUP) {
      this.hideDrugProviderData = (
        this.plan.attributes.PRODUCT_GROUP.toUpperCase() === PRODUCT_GROUPS.MEDIGAP.toUpperCase() ||
        this.plan.attributes.PRODUCT_GROUP.toUpperCase() === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT.toUpperCase() ||
        this.plan.attributes.PRODUCT_GROUP.toUpperCase() === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE.toUpperCase()
      );
    }
  }

  showDetailsBox() {
    return !this.hideDrugProviderData && (this.hasIndividualDrugs || this.hasSeniorDrugs || this.showProviderCoverage)
  }
  showMedicalDetails() {
    this.matDialog.open(MedicalDetailsModalComponent, {
      disableClose: false,
      maxWidth: '650px',
      maxHeight: '100vh',
      data: {
        type: 'Provider',
        providerCoverage: this.providerPlanInfo.providers
      }
    });
  }
}
